export const FETCH_CLASSES_FOR_SIGNUP = 'FETCH_CLASSES_FOR_SIGNUP';
export const FETCH_CLASSES_FOR_SIGNUP_SUCCESS = 'FETCH_CLASSES_FOR_SIGNUP_SUCCESS';
export const FETCH_CLASSES_FOR_SIGNUP_ERROR = 'FETCH_CLASSES_FOR_SIGNUP_ERROR';

export const fetchClassesForSignupAction = (payload) => {
    return (
        {
            type: FETCH_CLASSES_FOR_SIGNUP,
            payload,
        });
};

export const fetchClassesForSignupSuccessAction = (classes) => (
    {
        type: FETCH_CLASSES_FOR_SIGNUP_SUCCESS,
        classes,
    }
);

export const fetchClassesForSignupErrorAction = (error) => (
    {
        type: FETCH_CLASSES_FOR_SIGNUP_ERROR,
        error,
    }
);

const initialState = {
    fetching: false,
    classes: [],
    error: null,
};

export function classesForSignupReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_CLASSES_FOR_SIGNUP:
            return {
                ...state,
                fetching: true,
                error: null,
            };

        case FETCH_CLASSES_FOR_SIGNUP_SUCCESS:
            return {
                ...state,
                fetching: false,
                classes: action.classes,
                error: null,
            };

        case FETCH_CLASSES_FOR_SIGNUP_ERROR:
            return {
                ...state,
                fetching: false,
                error: action.error,
            };

        default:
            return state;
    }
}